import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position to top on route change (client-side navigation).
 * Placed inside the router in the root layout.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
